import React from "react";
import { ClipLoader } from "react-spinners";

const Loader = ({ loading, text = "Loading..." }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/70 z-50">
      <ClipLoader size={60} color="#2563eb" />
      <p className="mt-4 text-gray-700 text-lg">{text}</p>
    </div>
  );
};

export default Loader;
